<mat-sidenav-container class="sidenav-container">

  <!-- Side Navigation -->
  <mat-sidenav #sidenav
               [mode]="sidenavMode"
               [opened]="sidenavOpened"
               (openedChange)="sidenavOpened = $event"
               class="custom-sidenav-bg">
    <div class="sidenav-header">
      <span class="brand-logo">Scrims</span>
      <span class="environment-label">{{ environmentName }}</span>
    </div>

    <!-- Search Project -->
    <div class="sidebar-search-container" *ngIf="isClearanceUser">
      <mat-icon class="search-icon">search</mat-icon>
      <mat-form-field class="sidebar-search-field" appearance="fill">
        <mat-label>Search projects</mat-label>
        <input matInput
               [formControl]="term"
               [matAutocomplete]="auto">
        <mat-autocomplete #auto="matAutocomplete"
                          [panelClass]="['sidebar-search-autocomplete-panel']"
                          [displayWith]="displayProjectFn"
                          (optionSelected)="selectSearchedProject($event.option.value)">
          <mat-option *ngFor="let option of searchResults$ | async" [value]="option">
            {{ option.ProjectName }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <!-- Error loading projects -->
    <div class="error-item" *ngIf="errorLoadingProjects">
      <span>Error load projects - Refresh</span>
      <button mat-icon-button (click)="refreshLeftNav()">
        <mat-icon matTooltip="Reload projects">replay</mat-icon>
      </button>
    </div>

    <mat-divider *ngIf="isClearanceUser"></mat-divider>

    <!-- Recents -->
    <mat-nav-list class="recent-projects" *ngIf="isClearanceUser">
      <div class="section-header">
        <mat-icon>access_time</mat-icon>
        <span>Recents</span>
      </div>
      <ng-container *ngIf="recentProjects.length > 0; else noRecents">
        <mat-list-item *ngFor="let proj of recentProjects" class="project-item">
          <div class="project-item-row">
            <a class="project-link"
               [routerLink]="['/dashboard', proj.ProjectId]"
               routerLinkActive="active-project"
               [routerLinkActiveOptions]="{exact: true}">
              <span class="project-name">{{ proj.ProjectName }}</span>
              <span *ngIf="proj.NewCICount > 0" class="new-hint">{{ proj.NewCICount }}</span>
            </a>
            <button mat-icon-button
                    class="project-more-btn"
                    [matMenuTriggerFor]="recentMenu"
                    (click)="openProjOptions(proj); $event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          <mat-menu #recentMenu="matMenu" class="project-options-menu-panel" panelClass="project-options-menu-panel" [overlapTrigger]="false" yPosition="below">
            <button mat-menu-item class="project-options-menu-item" (click)="addProjectToFavList()" [disabled]="isAddToFavDisabled()">
              <mat-icon>favorite</mat-icon>
              <span>Add to favorites</span>
            </button>
          </mat-menu>
        </mat-list-item>
      </ng-container>
      <ng-template #noRecents>
        <div class="no-projects-text">No Recent Projects</div>
      </ng-template>
    </mat-nav-list>

    <mat-divider></mat-divider>

    <!-- Favorites -->
    <mat-nav-list class="favorite-projects">
      <div class="section-header">
        <mat-icon>favorite</mat-icon>
        <span>Favorites</span>
      </div>
      <ng-container *ngIf="favoriteProjects.length > 0; else noFavorites">
        <mat-list-item *ngFor="let favProj of favoriteProjects" class="project-item">
          <div class="project-item-row">
            <a class="project-link"
               [routerLink]="['/dashboard', favProj.ProjectId]"
               routerLinkActive="active-project"
               [routerLinkActiveOptions]="{exact: true}">
              <span class="project-name">{{ favProj.ProjectName }}</span>
              <span *ngIf="favProj.NewCICount > 0" class="new-hint">{{ favProj.NewCICount }}</span>
            </a>
            <button mat-icon-button
                    class="project-more-btn"
                    [matMenuTriggerFor]="favMenu"
                    (click)="openProjOptions(favProj); $event.stopPropagation()">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          <mat-menu #favMenu="matMenu" class="project-options-menu-panel"
            panelClass="project-options-menu-panel" [overlapTrigger]="false" yPosition="below">
            <button mat-menu-item class="project-options-menu-item" (click)="removeFromFavList()">
              <mat-icon>favorite_border</mat-icon>
              <span>Remove from favorites</span>
            </button>
          </mat-menu>
        </mat-list-item>
      </ng-container>
      <ng-template #noFavorites>
        <div class="no-projects-text">No Favorite Projects</div>
      </ng-template>
    </mat-nav-list>

    <!-- Sidenav-only spinner (no full-screen overlay; page routes use their own spinner) -->
    <spinner [isRunning]="isProjectPrefLoading" [overlay]="false"></spinner>
  </mat-sidenav>

  <!-- Main Content Area -->
  <mat-sidenav-content class="app-content-shell">

    <!-- Top Toolbar / Navbar -->
    <mat-toolbar color="primary" class="custom-navbar-bg">
      <!-- Mobile menu toggle -->
      <button mat-icon-button (click)="toggleMobileSidenav()" class="menu-toggle-btn" *ngIf="isMobile">
        <mat-icon>menu</mat-icon>
      </button>

      <!-- Project name -->
      <a class="navbar-project-name"
         [ngClass]="{ 'disabled-anchor': (!openedProject || openedProject.ProjectId == ''), 'anchor': (openedProject && openedProject.ProjectId != '') }"
         [routerLink]="(openedProject && openedProject.ProjectId != '') ? ['/dashboard', openedProject.ProjectId] : []">
        {{ currentProjectName }}
      </a>

      <span class="spacer"></span>

      <!-- Desktop nav icons -->
      <div class="navbar-menu-section">
        <!-- New project -->
        <button mat-icon-button matTooltip="new project" matTooltipPosition="below"
                [routerLink]="['./projectdetail']"
                [ngClass]="{'navbar-active': activeRoute('projectdetail')}"
                *ngIf="isClearanceUser && !_authService.readOnly">
          <mat-icon>movie_filter</mat-icon>
        </button>
        <!-- List view -->
        <button mat-icon-button matTooltip="list view" matTooltipPosition="below"
                [ngClass]="{'disabled-anchor': !openedProject, 'navbar-active': activeRoute('projects')}"
                (click)="openedProject && goToItemList()">
          <mat-icon>view_list</mat-icon>
        </button>
        <!-- Search -->
        <button mat-icon-button matTooltip="search" matTooltipPosition="below"
                [ngClass]="{'disabled-anchor': !openedProject, 'navbar-active': activeRoute('search')}"
                [routerLink]="openedProject ? ['./search'] : []">
          <mat-icon>search</mat-icon>
        </button>
        <!-- Help/Reference: STG Materialize hover:true; icons aligned right -->
        <button mat-icon-button
                #helpRefTrigger="matMenuTrigger"
                [matMenuTriggerFor]="helpRefMenu"
                (mouseenter)="openHelpRefMenu()"
                (mouseleave)="scheduleCloseHelpRefMenu()"
                (menuOpened)="onHelpRefMenuOpened()"
                (menuClosed)="onHelpRefMenuClosed()"
                [ngClass]="{'disabled-anchor': !helpReferenceDocumentsLoaded}">
          <mat-icon>folder</mat-icon>
        </button>
        <mat-menu #helpRefMenu="matMenu" class="help-ref-menu-panel"
                  [hasBackdrop]="false" [overlapTrigger]="false">
          <ng-container *ngIf="helpReferenceDocumentsLoaded">
            <button mat-menu-item *ngFor="let doc of helpReferenceDocuments" class="help-ref-item">
              <span class="subMenuDownloadLink" (click)="openHelpReferenceDocument(doc)"
                    [matTooltip]="doc.name" matTooltipPosition="left">{{ doc.name }}</span>
              <span class="help-ref-action" *ngIf="!isProductionUser && doc.isDefault"
                    (click)="uploadHelpReferenceDocument(doc); $event.stopPropagation()">
                <mat-icon class="subMenuActionIcon">cloud_upload</mat-icon>
              </span>
              <span class="help-ref-action"
                    *ngIf="!isProductionUser && !doc.isDefault && !_authService.readOnly"
                    (click)="deleteHelpReferenceDocument(doc); $event.stopPropagation()">
                <mat-icon class="subMenuActionIcon">delete</mat-icon>
              </span>
            </button>
            <button mat-menu-item *ngIf="!isProductionUser && !_authService.readOnly"
                    (click)="newHelpReferenceDocument()" class="help-ref-add">
              <mat-icon>add</mat-icon>
              <span>Add document</span>
            </button>
          </ng-container>
        </mat-menu>
        <!-- Reports -->
        <button mat-icon-button matTooltip="reports" matTooltipPosition="below"
                [ngClass]="{'disabled-anchor': !openedProject, 'navbar-active': activeRoute('reports')}"
                (click)="openedProject && goToReports()">
          <mat-icon>equalizer</mat-icon>
        </button>
        <!-- Address book -->
        <button mat-icon-button matTooltip="address book" matTooltipPosition="below"
                [routerLink]="['./addressbook']"
                [ngClass]="{'navbar-active': activeRoute('addressbook')}">
          <mat-icon>import_contacts</mat-icon>
        </button>
        <!-- User management -->
        <button mat-icon-button matTooltip="user management" matTooltipPosition="below"
                [routerLink]="['./usermanagement']"
                [ngClass]="{'navbar-active': activeRoute('usermanagement')}"
                *ngIf="isClearanceUser && !_authService.readOnly">
          <mat-icon>supervisor_account</mat-icon>
        </button>
        <!-- Download indicator -->
        <span class="navbar-menu-download-icon"
              [ngClass]="{'navbar-menu-download-icon-hidden': !downloadInProcess}"
              [matTooltip]="downloadTooltip" matTooltipPosition="below">
          <img src="../assets/icon/download-white.gif" alt="downloading" class="download-gif">
        </span>
        <!-- User name -->
        <span class="navbar-menu-user">
          <span class="navbar-menu-user-name">{{ appUserInfo.name }}</span>
        </span>
        <!-- Logout -->
        <a class="navbar-menu-logoff" href="https://login.myid.disney.com/logout">Log out</a>
      </div>

      <!-- Mobile menu -->
      <div class="navbar-mobile-section">
        <img src="../assets/icon/download-white.gif" alt="downloading"
             [ngClass]="{'navbar-menu-download-icon-hidden': !downloadInProcess}"
             class="download-gif">
        <button mat-icon-button [matMenuTriggerFor]="mobileMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #mobileMenu="matMenu">
          <button mat-menu-item [routerLink]="['./projectdetail']" *ngIf="isClearanceUser && !_authService.readOnly">
            <mat-icon>movie_filter</mat-icon>
            <span>New Project</span>
          </button>
          <button mat-menu-item [ngClass]="{'disabled-anchor': !openedProject}" (click)="openedProject && goToItemList()">
            <mat-icon>view_list</mat-icon>
            <span>List View</span>
          </button>
          <button mat-menu-item [ngClass]="{'disabled-anchor': !openedProject}" [routerLink]="openedProject ? ['./search'] : []">
            <mat-icon>search</mat-icon>
            <span>Search</span>
          </button>
          <button mat-menu-item [matMenuTriggerFor]="helpRefMenuMobile" [ngClass]="{'disabled-anchor': !isProjectLoaded}">
            <mat-icon>folder</mat-icon>
            <span>Help/Reference</span>
          </button>
          <button mat-menu-item [ngClass]="{'disabled-anchor': !openedProject}" (click)="openedProject && goToReports()">
            <mat-icon>equalizer</mat-icon>
            <span>Reports</span>
          </button>
          <button mat-menu-item [routerLink]="['./addressbook']">
            <mat-icon>import_contacts</mat-icon>
            <span>Address Book</span>
          </button>
          <a mat-menu-item href="https://login.myid.disney.com/logout">
            <span>Log out</span>
          </a>
        </mat-menu>
        <!-- Mobile Help/Reference sub-menu -->
        <mat-menu #helpRefMenuMobile="matMenu" class="help-ref-menu-panel" [hasBackdrop]="false">
          <ng-container *ngIf="isProjectLoaded">
            <button mat-menu-item *ngFor="let doc of helpReferenceDocuments" class="help-ref-item">
              <span class="subMenuDownloadLink" (click)="openHelpReferenceDocument(doc)"
                    [matTooltip]="doc.name" matTooltipPosition="left">{{ doc.name }}</span>
              <span class="help-ref-action" *ngIf="!isProductionUser && doc.isDefault"
                    (click)="uploadHelpReferenceDocument(doc); $event.stopPropagation()">
                <mat-icon class="subMenuActionIcon">cloud_upload</mat-icon>
              </span>
              <span class="help-ref-action"
                    *ngIf="!isProductionUser && !doc.isDefault && !_authService.readOnly"
                    (click)="deleteHelpReferenceDocument(doc); $event.stopPropagation()">
                <mat-icon class="subMenuActionIcon">delete</mat-icon>
              </span>
            </button>
            <button mat-menu-item *ngIf="!isProductionUser && !_authService.readOnly" (click)="newHelpReferenceDocument()">
              <mat-icon>add</mat-icon>
              <span>Add</span>
            </button>
          </ng-container>
        </mat-menu>
      </div>
    </mat-toolbar>

    <!-- Hidden file input for document uploads -->
    <input type="file" #documentInput (change)="onDocumentFileSelected($event)" class="hidden-file-input" />

    <!-- Main Content -->
    <main #appMainSection class="main-section" cdkScrollable
      [ngClass]="{ 'readonly-mode': _authService.readOnly }" (scroll)="onMainSectionScroll()">
      <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <footer>
      <div class="footer-fixed">
        <a href="https://disneytermsofuse.com/" class="footer-link" target="_blank"><span>Terms of Use</span></a>
        <a href="https://disneycasting.net/privacy/index.html" class="footer-link" target="_blank"><span>Privacy Policy</span></a>
      </div>
    </footer>
  </mat-sidenav-content>
</mat-sidenav-container>
<notifications></notifications>
